'use strict';

exports.__esModule = true;
exports.LinkContainer = exports.IndexLinkContainer = undefined;
var _IndexLinkContainer2 = require('./IndexLinkContainer');
var _IndexLinkContainer3 = _interopRequireDefault(_IndexLinkContainer2);
var _LinkContainer2 = require('./LinkContainer');
var _LinkContainer3 = _interopRequireDefault(_LinkContainer2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.IndexLinkContainer = _IndexLinkContainer3.default;
exports.LinkContainer = _LinkContainer3.default;